import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { RequiredLabel, InlineWarning, errorUtilities } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './simple-text-element.style.js';
import { getCurrentValue } from '../text-input';

export class SimpleTextElement extends Component {

  render() {
    const { maxLength, isRequired, hidden, label, tooltip, id, response, defaultValue, onChange, disabled, readOnly, errors, showErrors, css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');
    const inlineErrors = errors && errors.filter(err => err.type === errorUtilities.errorTypes.inline);
    const value = getCurrentValue(response, defaultValue);
    const maxLengthId = id + '-maxLength';

    if(hidden) return null;

    var textDisplay = readOnly ? (
      <p
        id={id}
        tabIndex={0}
        role={"textbox"}
        className={css.readOnlyText}
        aria-label={label}
        aria-required={isRequired}
        aria-invalid={hasErrors && showErrors}
        aria-describedby={errorIds + ' ' + maxLengthId}
        aria-readonly="true">
        {value}
      </p>
    ) : (
      <input
        id={id}
        type="text"
        maxLength={maxLength}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        readOnly={readOnly}
        className={css.text}
        aria-required={isRequired}
        aria-invalid={hasErrors && showErrors}
        aria-describedby={errorIds + ' ' + maxLengthId}
        value={value}/>
    );

    return (
      <div className={css.group}>
        <RequiredLabel
          hasErrors={hasErrors && showErrors}
          htmlFor={id}
          content={label}
          tooltip={tooltip}
          isRequired={isRequired}
          css={{
            requiredLabel: css.label,
            requiredIndicator: css.requiredIndicator}}/>
        <div className={css.inputWrapper}>
          {textDisplay}
          <span id={maxLengthId} className="skip">{maxLength ? maxLength + ' characters max' : '' }</span>
          {inlineErrors && inlineErrors.map(warn => (
            <InlineWarning key={warn.id} warn={!!response ? warn.errorMessage : null}/>
          ))}
        </div>
      </div>
    );
  }
}

SimpleTextElement.propTypes = {
  maxLength: PropTypes.number,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
};

export default styleable(defaultStyle) (SimpleTextElement);
